import { withAuthenticationRequired } from 'react-oidc-context';
import OohComponent from './OohComponent';
import RequireCountry from './RequireCountry';
import { CountryContext } from '../../core/hooks/useCountryContext';

const Ooh = () => {
  return (
    <div className="flex h-full dark:bg-design-black dark:text-white">
      <RequireCountry requiredCountry={CountryContext.RO}>
        <OohComponent />
      </RequireCountry>
    </div>
  );
};

export default withAuthenticationRequired(Ooh);
